import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-ink border-t border-ink-border px-6 md:px-12 py-10"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-manrope text-[11px] uppercase tracking-[0.25em] text-bone/50">
        <div>© {new Date().getFullYear()} Samuel Ortiz · Samoso</div>
        <div className="flex items-center gap-6">
          <a href="https://www.behance.net/samoso" target="_blank" rel="noreferrer" className="hover:text-bone">
            Behance
          </a>
          <a href="https://youtu.be/M_NnI5CosgQ" target="_blank" rel="noreferrer" className="hover:text-bone">
            Reel
          </a>
          <Link to="/admin/login" data-testid="admin-link" className="hover:text-bone">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
